import { css } from '@/styled-system/css';

export const tabsContainer = css({
  display: 'flex',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'hpxGrey400',
});

export const tab = css({
  flex: 1,
  paddingY: '1x',
  fontSize: 'sm',
  fontWeight: '600',
  textAlign: 'center',
  backgroundColor: 'transparent',
  border: 'none',
  borderBottomWidth: '2px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'transparent',
  color: 'hpxTeal500',
  cursor: 'pointer',
  transitionProperty: 'color, border-color',
  transitionDuration: '0.2s',
  _hover: {
    color: 'hpxBlue500',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const tabActive = css({
  color: 'hpxBlue600',
  borderBottomColor: 'hpxTeal500',
});

export const tabDisabled = css({
  color: 'hpxGrey600',
  cursor: 'not-allowed',
  _hover: {
    color: 'hpxGrey600',
  },
});
